import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { getBlogDataById } from "services/_blog";
import moment from "moment";
import "react-quill/dist/quill.snow.css";

const Blog = () => {
  const { id } = useParams();
  const [blogData, setBlogData] = useState({});
  const navigate = useNavigate();
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const fetchData = async () => {
      const data = await getBlogDataById(id);
      if (data.isSuccess) setBlogData(data.data);
    };
    fetchData();
  }, [id]);

  const handleNavigateBack = () => navigate("/blogs");

  return (
    <div style={{ backgroundColor: "#fff", paddingTop: "20px" }}>
      <section className="py-[30px] bg-white">
        <div className="container">
          {/* Back Button */}
          <button
            onClick={handleNavigateBack}
            style={{
              padding: "15px 0 0 25px",
              fontSize: "18px",
              color: "#000D44",
            }}
          >
            <i className="fas fa-arrow-left" style={{ paddingRight: "10px" }} />
            Blogs / {blogData.title}
          </button>

          {/* Blog Content */}
          <div className="grid my_bio my-[50px] gap-[50px] grid-cols-1 md:grid-cols-5">
            <div className="left_side md:col-span-2 flex justify-center ">
              {blogData.image_url && (
                <div className="mt-0">
                  <img
                    src={`${BACKEND_URL}${blogData.image_url}`}
                    alt={blogData.title}
                    style={{
                      width: "100%",
                      maxWidth: "500px",
                      height: "500px",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                </div>
              )}
            </div>
            <div className="right_side md:col-span-3 flex flex-col justify-start">
              <h1 className="md:text-[36px] text-[28px] text-[#000D44] font-[700] mb-2 text-right">
                {blogData.title}
              </h1>
              <h3 className="text-[18px] font-[400] mb-4 text-right">
                {blogData.created_at
                  ? moment(blogData.created_at).format("DD MMMM, YYYY")
                  : "-"}
              </h3>
              <p className="mb-4 text-right  text-black font-[500] ">
                {blogData.short_description}
              </p>
              <hr />

              <div
                className="mt-4 text-justify  text-black font-[500]"
                dangerouslySetInnerHTML={{ __html: blogData.content }}
              ></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;
